module.exports = (__webpack_public_path__ || '') + "static/images/photo-12-7fa37113bb8991e6f1270c42df8b1956.jpg";